import React, { useState, useEffect } from "react";
import axios from "axios";
import { Cookies } from "react-cookie";
import Loading from "../Loading";
import { ErrorAlert } from "../middleware/AlertMsg";
import { useNavigate } from "react-router-dom";
import { BsFillEyeFill } from "react-icons/bs";
import "./TransferRequest.css";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,TablePagination
} from '@mui/material';
import {HeaderTableCell,StyledTableRow,StyledTableCell} from '../Partials/TableStyle'

const AlltransferRequest = () => {
  const cookies = new Cookies();
  const token = cookies.get("JWTcookie");
  const [isLoading, setLoading] = useState(false);
  const [transferRequest, setTransferRequest] = useState();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");
  //const baseUrl = "https://officejeeves.com";
  const baseUrl =process.env.REACT_APP_BASE_URL;

  const getAllTransferRequests = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseUrl}/api/allTransferStockRequest`, {
        headers: { Authorization: "Bearer " + token },
      });
      const data = res.data?.data;
      const sortedData = data.sort((a, b) => {
        const dateA = new Date(
          a.createdAt.replace(/(\d{2})\/(\d{2})\/(\d{4}),/, "$2/$1/$3")
        );
        const dateB = new Date(
          b.createdAt.replace(/(\d{2})\/(\d{2})\/(\d{4}),/, "$2/$1/$3")
        );

        return dateB - dateA;
      });
     
      setTransferRequest(sortedData);
      // console.log("data: ", data);
      // console.log("transferRequest: ", transferRequest);
      setLoading(false);
    } catch (error) {
      // console.log(error);
      ErrorAlert({
        title: "Fail",
        message: error.message,
      });
    }
  };

  const getAllTransferRequestsById = async (id) => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${baseUrl}/api/allTransferStockRequestbyid?id=${id}`,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );
      console.log("res: ", res);
      console.log(id);
      navigate("../singleTransferStock", { state: res.data.data });
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllTransferRequests();
  }, []);
    // table related functions
    useEffect(() => {
      // Reset page to 0 after a search
      setPage(0);
  }, [searchQuery]);
  const handleChangePage = (event, newPage) => {
      setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
  };

  const handleSearch = (event) => {
      setSearchQuery(event.target.value);
  };

  const filteredData = transferRequest?.filter((item) => {
      return Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
  });
  // end table related functions
  return (
    <React.Fragment>
      <div className="maintransfer">
        <h3>ALL TRANSFER REQUESTS</h3>
        <div className="table-reponsive">
        <div className="search-div">
            <label>Search : </label>
            <input
              value={searchQuery}
              onChange={handleSearch}
              variant="outlined"
              size="small"
              // className="search-field"
            />
          </div>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <StyledTableRow>
                  <HeaderTableCell>S.No.</HeaderTableCell>
                  <HeaderTableCell>From</HeaderTableCell>
                  <HeaderTableCell>to</HeaderTableCell>
                  <HeaderTableCell>status</HeaderTableCell>
                  <HeaderTableCell>createdAt</HeaderTableCell>
                  <HeaderTableCell>Action</HeaderTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <StyledTableRow>
                  <StyledTableCell colSpan="6">
                    <Loading />
                  </StyledTableCell>
                </StyledTableRow>
              ) : (
                filteredData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((items, i) => (
                  <StyledTableRow key={items.id} sx={{
                    backgroundColor: i % 2 === 0 ? '#f5f5f5' : 'white',
                  }}>
                    <StyledTableCell align='center'> {i + 1} </StyledTableCell>
                    <StyledTableCell> {items?.fromWarehouse} </StyledTableCell>
                    <StyledTableCell> {items?.toWarehouse} </StyledTableCell>
                    <StyledTableCell> {items?.status} </StyledTableCell>
                    <StyledTableCell> {items?.createdAt} </StyledTableCell>
                    <StyledTableCell align='center'>
                      {" "}
                      <BsFillEyeFill
                        className="eye_icon hover-scale"
                        onClick={() => getAllTransferRequestsById(items._id)}
                      />{" "}
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              )}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={filteredData?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          </TableContainer>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AlltransferRequest;
